import { render } from "./GameDescriptionView.vue?vue&type=template&id=6b5d4246&scoped=true"
import script from "./GameDescriptionView.vue?vue&type=script&lang=js"
export * from "./GameDescriptionView.vue?vue&type=script&lang=js"

import "./GameDescriptionView.vue?vue&type=style&index=0&id=6b5d4246&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5d4246"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QToggle,QCard,QCardSection,QSpinner,QInput,QBtn,QDialog,QCardActions});qInstall(script, 'directives', {ClosePopup});
